import { Component, OnInit } from "@angular/core";
import { delay, retryWhen, take, tap } from "rxjs/operators";
import { ArticleModel } from "src/models/article.model";
import { ArticleService } from "src/services/article/article.service";

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
  articles: Array<ArticleModel>;
  limites: Array<ArticleModel>;
  loading: boolean;
  search: string;

  constructor(private articleService: ArticleService) {}

  ngOnInit(): void {
    this.loading = true;

    this.articleService.list().pipe(
      retryWhen(errors =>
        errors.pipe(
          delay(500),  // attendre 2s
          take(3),      // réessayer 3 fois
          tap(() => console.log('Nouvelle tentative...'))
        )
      )
    ).subscribe({
      next: (response) => {
        this.loading = false;
        this.articles = response;
      },
      error: (error) => {
        this.loading = true;
      },
    });

    this.loading = true;

    this.articleService.limit().pipe(
      retryWhen(errors =>
        errors.pipe(
          delay(500),  // attendre 2s
          take(3),      // réessayer 3 fois
          tap(() => console.log('Nouvelle tentative...'))
        )
      )
    ).subscribe({
      next: (response) => {
        this.loading = false;
        this.limites = response;
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  get filteredTeam() {
    if (
      this.search === null ||
      this.search === undefined ||
      this.search === ""
    ) {
      return this.articles;
    }

    return this.articles.filter((request) =>
      request.title.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  clearSearch() {
    this.search = '';
  }
}
